module.exports = __webpack_public_path__ + "img/627.da8447fc.jpg";